<main id="home">
    <div class="container-fluid">
        <nav class="navbar d-flex align-items-center justify-content-between">
            <div class="navbar-brand">
            </div>
            <div class="d-flex align-items-center">
                <button class="btn-opcoes" routerLink="../configuracao/usuarios">
                    <img class="img-btn-opcoes" src="../../assets/configuracoes.png" alt="">
                    <span>Configurações</span>
                </button>
                <button class="btn-opcoes" type="button" (click)="sair()">
                    <mat-icon class="mr-1">logout</mat-icon>
                    <span>Sair</span>
                </button>
            </div>
        </nav>
    </div>

    <div class="cards">
        <section class="card card-no-access fadeInUp" *ngIf="verificaSeMostraCardSemProdutos==0">
            <div class="icon">
                <mat-icon class="material-icons-sharp"
                    style="font-size: 4rem; width: 4rem; height: 4rem; color: var(--text-muted)">
                    sentiment_dissatisfied
                </mat-icon>
            </div>
            <h3>Sem acesso aos produtos</h3>
            <p class="descricao">Entre em contato com o suporte Agtech para solicitar acesso aos nossos produtos.</p>
            <button (click)="whatsapp()" style="background-color: #25D366; color: white;">
                Falar com Suporte
            </button>
        </section>

        <section class="card" *ngFor="let produto of produtosDisponiveis" [ngClass]="produto.classe">
            <div class="icon">
                <img [src]="produto.logo" [alt]="produto.nome">
            </div>
            <p class="descricao">
                {{ produto.descricao }}
            </p>
            <button (click)="produto.acao()" [disabled]="!verificarPermissao(produto.permissoes)">
                Acessar
            </button>
        </section>
    </div>

    <div class="load d-flex justify-content-center p-5" *ngIf="load">
        <mat-progress-spinner diameter=40 color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>

    <div class="Message" *ngIf="aviso==true">
        <div class="d-flex align-items-stretch">
            <div class="Message-icon">
                <mat-icon>error</mat-icon>
            </div>
            <div class="Message-body">
                <button class="Message-close" (click)="fecharAviso()">
                    <mat-icon style="font-size: 18px;">close</mat-icon>
                </button>
                <p style="color: var(--text-main);">Há contratos prestes a vencer</p>
                <p style="font-size: 0.8rem; color: var(--text-muted); font-weight: 400;">
                    Entre em contato com o suporte para mais informações.
                </p>
            </div>
        </div>
        <div class="round-time-bar">
            <div></div>
        </div>
    </div>
</main>